<div
  *ngIf="routeData"
  [class]="{ main: !routeData.isPreLogin, prelogin: routeData.isPreLogin }"
>
  <div class="bar-menu-component">
    <cs-logo-bar-component
      [isAuthenticated]="isAuthenticated"
      [isPreLogin]="routeData.isPreLogin"
    >
    </cs-logo-bar-component>
  </div>
  <menu-component
    *ngIf="isAuthenticated && !routeData.isPreLogin"
    [userId]="userId"
  ></menu-component>
  <!--  <cs-page-header *ngIf="isAuthenticated && !routeData.isPreLogin && !routeData.isDashboard" [title]="title" [isFullView]="isFullView">
  </cs-page-header> -->
  <!-- <cs-custom-theme [theme]="theme" [radius]="radius"></cs-custom-theme> -->
  <div [class]="{ themeContent: isFullView }">
    <router-outlet></router-outlet>
  </div>
  <app-acceptance194-r></app-acceptance194-r>
  <cs-prelogin-footer-component></cs-prelogin-footer-component>
  <!-- <div class="globalFooter">
    <cs-prelogin-footer-component [isAuthenticated]="isAuthenticated"></cs-prelogin-footer-component>
    <div class="cookie-position-absolute">
      <app-cookie-component></app-cookie-component>
    </div>
      </div> -->
</div>
